/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/** Versions */
export var Versions;
(function (Versions) {
    Versions["Latest"] = "latest";
    Versions["All"] = "all";
})(Versions || (Versions = {}));
/**
 * Source
 * Config source choices.
 */
export var Source;
(function (Source) {
    Source["Tilstandomatic"] = "tilstandomatic";
    Source["ModelEditor"] = "model_editor";
    Source["Dieta"] = "dieta";
    Source["Other"] = "other";
})(Source || (Source = {}));
/**
 * PredictionStatus
 * Prediction statuses.
 */
export var PredictionStatus;
(function (PredictionStatus) {
    PredictionStatus["Successful"] = "successful";
    PredictionStatus["Failed"] = "failed";
    PredictionStatus["Pending"] = "pending";
    PredictionStatus["Offline"] = "offline";
})(PredictionStatus || (PredictionStatus = {}));
/** PipelineStatus */
export var PipelineStatus;
(function (PipelineStatus) {
    PipelineStatus["Running"] = "Running";
    PipelineStatus["Failed"] = "Failed";
    PipelineStatus["Successful"] = "Successful";
    PipelineStatus["Unavailable"] = "Unavailable";
})(PipelineStatus || (PipelineStatus = {}));
/** PausedFilter */
export var PausedFilter;
(function (PausedFilter) {
    PausedFilter["All"] = "all";
    PausedFilter["Paused"] = "paused";
    PausedFilter["NotPaused"] = "not_paused";
})(PausedFilter || (PausedFilter = {}));
/**
 * ModelStatus
 * Model status choices.
 */
export var ModelStatus;
(function (ModelStatus) {
    ModelStatus["Undefined"] = "undefined";
    ModelStatus["Training"] = "training";
    ModelStatus["Stopped"] = "stopped";
    ModelStatus["Running"] = "running";
    ModelStatus["Aml"] = "aml";
    ModelStatus["Deprecated"] = "deprecated";
    ModelStatus["Failed"] = "failed";
})(ModelStatus || (ModelStatus = {}));
/**
 * ModelEntityStatusType
 * Model entity status type.
 */
export var ModelEntityStatusType;
(function (ModelEntityStatusType) {
    ModelEntityStatusType["New"] = "new";
    ModelEntityStatusType["Active"] = "active";
    ModelEntityStatusType["Archived"] = "archived";
    ModelEntityStatusType["Paused"] = "paused";
})(ModelEntityStatusType || (ModelEntityStatusType = {}));
/** ModelEditorImportStatus */
export var ModelEditorImportStatus;
(function (ModelEditorImportStatus) {
    ModelEditorImportStatus["Successful"] = "successful";
    ModelEditorImportStatus["Failed"] = "failed";
})(ModelEditorImportStatus || (ModelEditorImportStatus = {}));
/** JobStatus */
export var JobStatus;
(function (JobStatus) {
    JobStatus["Requested"] = "Requested";
    JobStatus["SentToAML"] = "SentToAML";
    JobStatus["NotStarted"] = "NotStarted";
    JobStatus["Queued"] = "Queued";
    JobStatus["Preparing"] = "Preparing";
    JobStatus["Starting"] = "Starting";
    JobStatus["Running"] = "Running";
    JobStatus["Finalizing"] = "Finalizing";
    JobStatus["Completed"] = "Completed";
    JobStatus["FailedToStart"] = "FailedToStart";
    JobStatus["Failed"] = "Failed";
    JobStatus["MachineOffline"] = "MachineOffline";
    JobStatus["Imputed"] = "Imputed";
    JobStatus["MissingData"] = "MissingData";
    JobStatus["Canceled"] = "Canceled";
    JobStatus["CancelRequested"] = "CancelRequested";
    JobStatus["EquipmentPaused"] = "EquipmentPaused";
})(JobStatus || (JobStatus = {}));
/**
 * EventUserType
 * Enumeration of user types in events.
 */
export var EventUserType;
(function (EventUserType) {
    EventUserType["Engineer"] = "engineer";
    EventUserType["DataScientist"] = "data_scientist";
})(EventUserType || (EventUserType = {}));
/**
 * EventSourceType
 * Origin type of event.
 */
export var EventSourceType;
(function (EventSourceType) {
    EventSourceType["Manual"] = "manual";
    EventSourceType["Auto"] = "auto";
})(EventSourceType || (EventSourceType = {}));
/**
 * EventInteractionStatus
 * Interaction status of an event.
 */
export var EventInteractionStatus;
(function (EventInteractionStatus) {
    EventInteractionStatus["New"] = "new";
    EventInteractionStatus["MonitoringWatchlist"] = "monitoring_watchlist";
    EventInteractionStatus["Archived"] = "archived";
    EventInteractionStatus["ReadyForTraining"] = "ready_for_training";
    EventInteractionStatus["Trained"] = "trained";
})(EventInteractionStatus || (EventInteractionStatus = {}));
/** EventAlarmStatus */
export var EventAlarmStatus;
(function (EventAlarmStatus) {
    EventAlarmStatus["Active"] = "active";
    EventAlarmStatus["Inactive"] = "inactive";
})(EventAlarmStatus || (EventAlarmStatus = {}));
/** EventActionName */
export var EventActionName;
(function (EventActionName) {
    EventActionName["RedefineTrainingPeriod"] = "redefine_training_period";
    EventActionName["ExcludeFromTrainingPeriod"] = "exclude_from_training_period";
    EventActionName["AddToTrainingPeriod"] = "add_to_training_period";
})(EventActionName || (EventActionName = {}));
/**
 * EquipmentSource
 * Source of equipment data.
 */
export var EquipmentSource;
(function (EquipmentSource) {
    EquipmentSource["ModelEditor"] = "model_editor";
    EquipmentSource["Tilstandomatic"] = "tilstandomatic";
})(EquipmentSource || (EquipmentSource = {}));
/** EquipmentPausedFilter */
export var EquipmentPausedFilter;
(function (EquipmentPausedFilter) {
    EquipmentPausedFilter["All"] = "all";
    EquipmentPausedFilter["Paused"] = "paused";
    EquipmentPausedFilter["NotPaused"] = "not_paused";
})(EquipmentPausedFilter || (EquipmentPausedFilter = {}));
/** DerivativeOperations */
export var DerivativeOperations;
(function (DerivativeOperations) {
    DerivativeOperations["TagAnomalyScaled"] = "tag-anomaly-scaled";
    DerivativeOperations["ModelOutput"] = "model-output";
})(DerivativeOperations || (DerivativeOperations = {}));
/**
 * ConfigStatus
 * Config status choices.
 */
export var ConfigStatus;
(function (ConfigStatus) {
    ConfigStatus["ValidationStarted"] = "validation_started";
    ConfigStatus["Valid"] = "valid";
    ConfigStatus["Invalid"] = "invalid";
    ConfigStatus["DeliveredToGordo"] = "delivered_to_gordo";
    ConfigStatus["Archived"] = "archived";
    ConfigStatus["ArchivedInvalid"] = "archived_invalid";
    ConfigStatus["Store"] = "store";
})(ConfigStatus || (ConfigStatus = {}));
/** AggregateOperations */
export var AggregateOperations;
(function (AggregateOperations) {
    AggregateOperations["TotalAnomalyConfidence"] = "total-anomaly-confidence";
})(AggregateOperations || (AggregateOperations = {}));
/**
 * ActivityLogType
 * Activity log type.
 */
export var ActivityLogType;
(function (ActivityLogType) {
    ActivityLogType["Comment"] = "comment";
    ActivityLogType["Change"] = "change";
})(ActivityLogType || (ActivityLogType = {}));
